export default __webpack_public_path__ + "static/media/Ramp2.68272ed6.jpg";